const HOUR = 3600;
const DAY = 24 * HOUR;
export const FREE_CANCEL_HOURS = 48;

export function makeStay(late, t0) {
  const checkIn = t0 + (late ? 1 : 5) * DAY;
  return {
    merchant: 'hotel.example', orderRef: 'RES-30001', room: 'King room, 2 nights', checkIn,
    checkOut: checkIn + 2 * DAY, deadline: checkIn - FREE_CANCEL_HOURS * HOUR,
    policy: 'Free cancellation until 48 hours before check-in. After that, one night is charged.',
  };
}

export const gap = (s) => {
  const d = Math.floor(s / DAY);
  const h = Math.floor((s % DAY) / HOUR);
  return `${d} day${d === 1 ? '' : 's'} ${h} hour${h === 1 ? '' : 's'}`;
};

export const stamp = (t) => new Date(t * 1000).toISOString().replace('T', ' ').slice(0, 16) + ' UTC';
